import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Foundation from "./pages/Foundation";
import InThePress from "./pages/InThePress";
import Contact from "./pages/Contact";
import ScrollToTop from "./ScrollToTop";
import Books from "./pages/Books";
import Presentations from "./pages/Presentations";


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/foundation" element={<Foundation />} />
            <Route path="/inthepress" element={<InThePress />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/books" element={<Books />} />
            <Route path="/presentations" element={<Presentations />} />

          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
